export const ListQueryKey = 'projectLoveSpreadRecords';
export const DetailQueryKey = 'projectLoveSpreadRecord';

export const Urls = {
  selectUrl: '/loveSpreadRecord/list',
  updateUrl: '/loveSpreadRecord/update',
  deleteUrl: '/loveSpreadRecord/delete',
  createUrl: '/loveSpreadRecord/create',
  detailUrl: '/loveSpreadRecord/info',
};
